export const ACTIONS = {
    loadTournament: 'ui/CHANGE'
};

const defaultState = {
    tournament: null,
    seasonId: null,
    season: null,

    nearestEvents: [],
    hashImagePreviewEnable: true,
    hashImagePreviewFailedCount: 0,
    event: null,
    team: null,

    widgets: [],
    templates: []
};

const reducer = (state = defaultState, action) => {
    const { type, payload } = action;

    switch (action.type) {
        case `initLoad`:
            return { ...state, ...payload };
        case `hashPreviewFailed`:
            const hashImagePreviewFailedCount = state.hashImagePreviewFailedCount + 1;
            const hashImagePreviewEnable = hashImagePreviewFailedCount <= 3;
            return { ...state, hashImagePreviewFailedCount, hashImagePreviewEnable };
        case `eventLoaded`:
            return { ...state, event: payload };
        case 'bulk':
            return { ...state, ...payload };
        default:
            return state;
    }
};

export default reducer;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/pages/reducer.js
 **/